import { toast } from 'react-toastify';
import errorHandle from '../../../utils/errorHandle';
import { faqDeleteFun } from '../../../api/addDataAPI';

//Delete faq
export const deleteFaq = async (id, setLoading, refresh, setDeleteModal) => {
    try {
        await faqDeleteFun(id);
        toast.success(`Faq deleted successfully`);
        setLoading(false);
        setDeleteModal(false);
        refresh();
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
